import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import LiveCamera from "./components/livecamera";
// import React, { useRef, useState } from "react";
import Webcam from "react-webcam";
import { useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

const RequisitionPO = () => {
  const webcamRefs = useRef([]);
  const viewModalRef = useRef(null);

  const exportModalToCSV = () => {
    try {
      if (!itemDetails || itemDetails.length === 0) {
        alert("No data to export.");
        return;
      }

      const columns = [
        "S.No.",
        "Category Name",
        "Vendor Name",
        "Item",
        "Requested",
        "Required Date",
        "Approved",
        "Approve Date",
        "Received",
        "Price (INR)",
        "Amount (INR)",
      ];

      const escape = (val) => {
        if (val == null) return "";
        const s = String(val).replace(/\r?\n|\r/g, " ");
        if (s.includes(",") || s.includes('"')) return `"${s.replace(/"/g, '""')}"`;
        return s;
      };

      const formatDate = (s) =>
        s
          ? new Date(s).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          : "-";

      const rows = itemDetails.map((item, index) => {
        const price = parseFloat(item.price) || 0;
        const receivedQty =
          item.recieved_quantity !== 0 && item.recieved_quantity != null
            ? parseFloat(item.recieved_quantity) || 0
            : parseFloat(inputrecievedata[index]?.recivedquantity) || 0;
        const amount = price * receivedQty;

        return [
          index + 1,
          item.category_name || "-",
          item.vendor_name || "-",
          item.stock || "-",
          item.requestquantity ?? "-",
          formatDate(item.required_date),
          item.approve_quantity ?? "-",
          formatDate(item.approve_date),
          receivedQty || "-",
          price.toFixed(2),
          amount.toFixed(2),
        ];
      });

      // Totals row
      const totals = calculateTotals();
      const totalsRow = [
        "",
        "",
        "",
        "GRAND TOTAL",
        totals.totalRequested,
        "",
        totals.totalApproved,
        "",
        totals.totalReceived,
        "",
        totals.totalAmount,
      ];

      const csvLines = [
        columns.map(escape).join(","),
        ...rows.map((r) => r.map(escape).join(",")),
        totalsRow.map(escape).join(","),
      ];
      const csvContent = csvLines.join("\n");
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `Requisition_Details_${new Date().toISOString().slice(0, 10)}.csv`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(blobUrl);
    } catch (err) {
      console.error("CSV export failed:", err);
      alert("Failed to export CSV.");
    }
  };

  const exportModalToPDF = async () => {
    if (!viewModalRef.current) return;
    const el = viewModalRef.current;
    // Save original inline styles so we can restore them
    const originalHeight = el.style.height;
    const originalMaxHeight = el.style.maxHeight;
    const originalOverflow = el.style.overflowY;
    const originalWidth = el.style.width;

    // Also expand any inner .table-responsive wrappers that may clip horizontally
    const responsives = el.querySelectorAll(".table-responsive");
    const savedResponsives = [];
    responsives.forEach((r) => {
      savedResponsives.push({ el: r, overflow: r.style.overflow, overflowX: r.style.overflowX });
      r.style.overflow = "visible";
      r.style.overflowX = "visible";
    });

    try {
      // Expand the modal body so html2canvas sees ALL rows and the full table width
      el.style.height = "auto";
      el.style.maxHeight = "none";
      el.style.overflowY = "visible";
      el.style.width = "auto";

      // Let the browser re-layout
      await new Promise((resolve) => setTimeout(resolve, 150));

      const fullWidth = el.scrollWidth;
      const fullHeight = el.scrollHeight;

      const canvas = await html2canvas(el, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        scrollX: 0,
        scrollY: 0,
        windowWidth: fullWidth,
        windowHeight: fullHeight,
        width: fullWidth,
        height: fullHeight,
      });

      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginX = 10;
      const marginTop = 15;
      const marginBottom = 10;
      const usableWidth = pageWidth - marginX * 2;
      const usableHeight = pageHeight - marginTop - marginBottom;

      // How many source-canvas pixels fit on one PDF page
      const pxPerMm = canvas.width / usableWidth;
      const sliceHeightPx = Math.floor(usableHeight * pxPerMm);

      pdf.setFontSize(14);
      pdf.text("Requisition Details Report", pageWidth / 2, 10, { align: "center" });

      let renderedPx = 0;
      let pageIndex = 0;
      while (renderedPx < canvas.height) {
        const remainingPx = canvas.height - renderedPx;
        const currentSlicePx = Math.min(sliceHeightPx, remainingPx);

        // Create a temporary canvas for this slice
        const sliceCanvas = document.createElement("canvas");
        sliceCanvas.width = canvas.width;
        sliceCanvas.height = currentSlicePx;
        const ctx = sliceCanvas.getContext("2d");
        ctx.fillStyle = "#ffffff";
        ctx.fillRect(0, 0, sliceCanvas.width, sliceCanvas.height);
        ctx.drawImage(
          canvas,
          0, renderedPx, canvas.width, currentSlicePx,
          0, 0, canvas.width, currentSlicePx
        );

        const sliceData = sliceCanvas.toDataURL("image/png");
        const sliceHeightMm = currentSlicePx / pxPerMm;

        if (pageIndex > 0) {
          pdf.addPage();
          pdf.setFontSize(14);
          pdf.text("Requisition Details Report", pageWidth / 2, 10, { align: "center" });
        }
        pdf.addImage(sliceData, "PNG", marginX, marginTop, usableWidth, sliceHeightMm);

        renderedPx += currentSlicePx;
        pageIndex += 1;
      }

      pdf.save(`Requisition_Details_${new Date().toISOString().slice(0, 10)}.pdf`);
    } catch (err) {
      console.error("PDF export failed:", err);
      alert("Failed to export PDF. Please try again.");
    } finally {
      // Restore all original styles
      el.style.height = originalHeight;
      el.style.maxHeight = originalMaxHeight;
      el.style.overflowY = originalOverflow;
      el.style.width = originalWidth;
      savedResponsives.forEach(({ el: r, overflow, overflowX }) => {
        r.style.overflow = overflow;
        r.style.overflowX = overflowX;
      });
    }
  };
  const [capturedImages, setCapturedImages] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [itemOptions, setItemOptions] = useState([]);
  const [allItemRows, setAllItemRows] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState("");
  const [webcamRow, setWebcamRow] = useState(null);
  const [currentFacingMode, setCurrentFacingMode] = useState("user");
  const [startDateFilter, setStartDateFilter] = useState("");
  const [endDateFilter, setEndDateFilter] = useState("");
  const navigate = useNavigate();

  const captureImage = async (itemId) => {
    const webcamInstance = webcamRefs.current[itemId]?.current;
    const imageSrc = webcamInstance?.getScreenshot();
    if (!imageSrc) return;
    setCapturedImages((prev) => ({ ...prev, [itemId]: imageSrc }));
    try {
      const blob = await fetch(imageSrc).then((res) => res.blob());
      const file = new File([blob], `image_${itemId}.jpg`, {
        type: "image/jpeg",
      });
      const formData = new FormData();
      formData.append("file", file);
      formData.append("itemids", itemId);

      const response = await fetch(
        "https://ims-backend.indevconsultancy.in/api/uploadphoto/",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        if (response.status === 401) {
          console.error("User not authenticated");
          window.location.href = "/login";
          return;
        }
        throw new Error(errorData.message || "Upload failed");
      }

      const result = await response.json();

      console.log("Image uploaded successfully:", result);
    } catch (error) {
      console.error("Upload error:", error);
      alert(error.message || "Failed to upload image");
    } finally {
      setWebcamRow(null);
      setCurrentFacingMode("user");
    }
  };

  const removeImage = () => {
    setCapturedImages([]);
    setCapturedImagesPanding([]);
  };

  const [stockItems, setStockItems] = useState([]);
  const [kitchenId, setKitchenId] = useState(null);
  const [requisitionList, setRequisitionList] = useState([]);
  const [formData, setFormData] = useState({ itemName: "", quantity: "" });
  const today = new Date().toISOString().split("T")[0];

  const [inputGroups, setInputGroups] = useState([
    {
      item: "",
      available: 100,
      quantity: "",
      date: today,
      category_item: "",
      vendor_id: "",
    },
  ]);

  const [selectedItemId, setSelectedItemId] = useState(null);
  const [REID, setSelectedREID] = useState("");
  const [REID1, setSelectedREID1] = useState("");
  const [itemDetails, setItemDetails] = useState([]);
  const [stockOptions, setStockOptions] = useState([]);
  const [stockCategory, setCategory] = useState([]);
  const [stockVendor, setvendor] = useState([]);
  const [filterDate, setFilterDate] = useState("");
  const [filterRequisitionDate, setRequisitionDate] = useState("");

  const [inputrecievedata, setinputrecievedata] = useState([
    { receivedQuantity: "" }, // One object per row
  ]);

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(requisitionList.length / itemsPerPage);
  const paginatedList = requisitionList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      setKitchenId(user.kitchen);
      axios
        .get(
          `https://ims-backend.indevconsultancy.in/api/kitchen-stock-reports/by-kitchen/${user.kitchen}/`
        )
        .then((res) => {
          const formatted = res.data.map((item) => ({
            kitchenstock_id: item.kitchenstock_id,
            stock_name: item.stock_name,
            quantity: item.quantity,
            required_quantity: "",
            required_date: "",
          }));
          setStockItems(formatted);
        })
        .catch((err) => console.error("Error fetching kitchen stock:", err));
    }
  }, []);

  useEffect(() => {
    fetchRequisitionList();
  }, []);

  // fetch vendors once and normalize response shape
  useEffect(() => {
    const loadVendors = async () => {
      try {
        const res = await axios.get(
          "https://ims-backend.indevconsultancy.in/admin-panel/vendor/"
        );
        // API returns an array as res.data in your sample — handle both shapes defensively
        const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
        setVendors(Array.isArray(list) ? list : []);
      } catch (err) {
        console.error("Failed to fetch vendors:", err);
        setVendors([]);
      }
    };

    loadVendors();
  }, []);

  // fetch all item rows once → used for Item dropdown options + reqid filtering
  useEffect(() => {
    const loadItems = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const kitchen = user?.kitchen;
        if (!kitchen) return;
        const res = await axios.get(
          `https://api-ims.indevconsultancy.in/requisition_export_report.php?kitchen_id=${kitchen}`
        );
        const rows = Array.isArray(res.data) ? res.data : res.data?.data || [];
        setAllItemRows(rows);
        const uniqueNames = Array.from(
          new Set(rows.map((r) => (r.stock_name || "").trim()).filter(Boolean))
        ).sort((a, b) => a.localeCompare(b));
        setItemOptions(uniqueNames);
      } catch (err) {
        console.error("Failed to fetch item options:", err);
        setItemOptions([]);
      }
    };
    loadItems();
  }, []);

  const stocksItem = (categoryId, index) => {
    axios
      .get(
        `https://ims-backend.indevconsultancy.in/api/stocks/?category_id=${categoryId}`
      )
      .then((res) => {
        const updatedStockOptions = [...stockOptions];
        updatedStockOptions[index] = res.data;
        setStockOptions(updatedStockOptions);
      })
      .catch((err) => console.error("Error fetching stock options:", err));
  };

  useEffect(() => {
    axios
      .get("https://ims-backend.indevconsultancy.in/admin-panel/category/")
      .then((res) => setCategory(res.data))
      .catch((err) => console.error("Error fetching stock options:", err));
  }, []);

  const statusMap = {
    0: "Request",
    1: "Approved",
    2: "Recieved",
    3: "Pending",
    4: "Delete",
  };
  const statusColorMap = {
    0: "secondary",
    1: "warning",
    2: "success",
    3: "warning",
    4: "danger",
  };

  const fetchRequisitionItemDetails = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      const allItems = response.data.requisitiondataitem || [];
      // If an Item filter is active, show ONLY items matching the filter
      const items = selectedItem
        ? allItems.filter(
          (it) =>
            (it.stock || it.stock_name || "")
              .toString()
              .trim()
              .toLowerCase() === selectedItem.toLowerCase()
        )
        : allItems;

      setItemDetails(items);

      // Calculate total amount and update the requisition in the list
      const totalAmount = items.reduce((sum, item) => {
        const price = parseFloat(item.price) || 0;
        const quantity = parseFloat(item.recieved_quantity || item.requestquantity || 0);
        return sum + (price * quantity);
      }, 0);

      // Update the requisition list with the calculated total
      setRequisitionList(prevList =>
        prevList.map(req =>
          req.reqid === pk
            ? { ...req, total_amount: totalAmount.toFixed(2), items: items }
            : req
        )
      );

    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  const [formErrors, setFormErrors] = useState([]);
  const handleSubmit = async (e) => {
    e.preventDefault();

    let isValid = true;
    let errorMessages = [];

    inputGroups.forEach((group, index) => {
      if (!group.date) {
        isValid = false;
        errorMessages.push(
          `Row ${index + 1}: Please select the Date of Received.`
        );
      }
      if (!group.item) {
        isValid = false;
        errorMessages.push(`Row ${index + 1}: Item name is required.`);
      }
      if (!group.quantity || group.quantity <= 0) {
        isValid = false;
        errorMessages.push(
          `Row ${index + 1}: Quantity must be greater than 0.`
        );
      }
      if (!group.category_item) {
        isValid = false;
        errorMessages.push(`Row ${index + 1}: Category is required.`);
      }
    });
    if (!isValid) {
      setFormErrors(errorMessages);
      return;
    } else {
      setFormErrors([]);
    }
    try {
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/add-request-items",
        {
          items: inputGroups.map((group) => ({
            item: group.item,
            quantity: group.quantity,
            kitchenId: kitchenId,
            available: "",
            date: group.date,
            category: group.category_item,
            vendor_id: group.vendor_id,
          })),
        }
      );

      if (response.status === 200 || response.status === 201) {
        setInputGroups([
          {
            item: "",
            available: 100,
            quantity: "",
            date: today,
            category_item: "",
            vendor_id: "",
          },
        ]);
        fetchRequisitionList();
        const modalEl = document.getElementById("registerModal");
        const modal = bootstrap.Modal.getInstance(modalEl);
        modal.hide();
      } else {
        alert("Failed to save items");
      }
    } catch (error) {
      console.error("API error:", error);
      alert("An error occurred while saving data");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    fetchRequisitionList(startDateFilter, endDateFilter);
  };

  const addInputGroup = () => {
    setInputGroups([
      ...inputGroups,
      {
        item: "",
        available: 100,
        quantity: "",
        date: today,
        category_item: "",
      },
    ]);
  };

  const removeInputGroup = (index) => {
    const updated = [...inputGroups];
    updated.splice(index, 1);
    setInputGroups(updated);
  };

  const handleInputChange = (index, field, value) => {
    const updated = [...inputGroups];
    updated[index][field] = value;
    setInputGroups(updated);
  };

  // Simplified fetchRequisitionList without additional API calls
  const fetchRequisitionList = (startDate = "", endDate = "") => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user?.kitchen) {
      let url = `https://api-ims.indevconsultancy.in/requistion-list.php?kitchen_id=${user?.kitchen}`;
      const params = [];

      if (startDate) params.push(`start_date=${encodeURIComponent(startDate)}`);
      if (endDate) params.push(`end_date=${encodeURIComponent(endDate)}`);
      if (selectedVendor) params.push(`vendor_id=${encodeURIComponent(selectedVendor)}`);

      if (params.length > 0) {
        url += `&${params.join("&")}`;
      }

      axios
        .get(url)
        .then((response) => {
          if (response.data.requisitiondata) {
            // Process the data without additional API calls
            const processedData = response.data.requisitiondata.map(req => {
              // Check if the response already contains total_amount
              if (req.total_amount) {
                return { ...req, total_amount: parseFloat(req.total_amount).toFixed(2) };
              }

              // If the response has items array, calculate total
              if (req.items && Array.isArray(req.items)) {
                const total = req.items.reduce((sum, item) => {
                  const price = parseFloat(item.price) || 0;
                  const quantity = parseFloat(item.recieved_quantity || item.requestquantity || 0);
                  return sum + (price * quantity);
                }, 0);
                return { ...req, total_amount: total.toFixed(2) };
              }

              // Default fallback
              return { ...req, total_amount: "0.00" };
            });

            // Apply item filter (only show requisitions that contain selected item)
            let finalData = processedData;
            if (selectedItem && allItemRows.length > 0) {
              const matchingReqIds = new Set(
                allItemRows
                  .filter(
                    (r) =>
                      (r.stock_name || "").trim().toLowerCase() ===
                      selectedItem.toLowerCase()
                  )
                  .map((r) => String(r.reqid))
              );
              finalData = processedData.filter((req) =>
                matchingReqIds.has(String(req.reqid))
              );
            }

            setRequisitionList(finalData);
            setCurrentPage(1);
          } else {
            setRequisitionList([]);
            setCurrentPage(1);
          }
        })
        .catch((error) => {
          console.error("Failed to fetch requisition list:", error);
          alert("Unable to load requisitions. Please try again later.");
        });
    }
  };

  const [itemDetailsSaveData, setItemDetailsSaveData] = useState([]);
  const [selectedVendorId, setSelectedVendorId] = useState("");
  const [selectedDateofReceived, setSelectedDateofReceived] = useState("");

  useEffect(() => {
    const today = new Date().toISOString().split("T")[0]; // Formats as 'YYYY-MM-DD'
    setSelectedDateofReceived(today);
  }, []);

  const handleInputChangeMRN = (index, field, value) => {
    const updatedDetails = [...itemDetails];
    console.log(updatedDetails);
    updatedDetails[index][field] = value;
    setItemDetailsSaveData(updatedDetails);
  };

  const handleSubmitMRN = async () => {
    try {
      const payload = {
        requisition_id: REID1,
        date_of_order: selectedDateofReceived,
        vendor_id: selectedVendorId,
        items: itemDetailsSaveData,
      };
      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/sumit-request-items",
        payload
      );
      fetchRequisitionList();
    } catch (error) {
      console.error("Submission failed:", error);
      alert("Error submitting requisition");
    }
  };

  const handlereceivedvalue = (index, field, value) => {
    const updatedGroups = [...inputrecievedata];
    if (!updatedGroups[index]) {
      updatedGroups[index] = {};
    }
    // Use parseFloat so price (decimals) and quantity both work
    const parsedValue = parseFloat(value);
    updatedGroups[index][field] = isNaN(parsedValue) ? 0 : parsedValue;

    if (itemDetails[index]) {
      updatedGroups[index].itemid = itemDetails[index].id;
      updatedGroups[index].kitchenid = kitchenId;
      // updatedGroups[index].stock_id = kitchenId;
    }

    setinputrecievedata(updatedGroups);
  };

  // Helper: returns true if item's edit window (24 hrs after receive) has expired
  const isReceiveLocked = (item) => {
    if (!item) return false;
    // Not yet received → still editable
    const received = parseFloat(item.recieved_quantity || 0);
    if (received === 0 || !item.recieve_date) return false;
    const elapsed = Date.now() - new Date(item.recieve_date).getTime();
    return elapsed > 24 * 60 * 60 * 1000; // > 24 hours
  };


  useEffect(() => {
    if (itemDetails.length > 0) {
      // Pre-fill input array with all required fields backend needs.
      // For unreceived items, recivedquantity & price stay empty (user enters fresh).
      // For already-received items (within 24h window), pre-fill so edits work.
      const initialData = itemDetails.map((it) => {
        const alreadyReceived = parseFloat(it.recieved_quantity || 0) > 0;
        return {
          ...it, // carry all original fields (id, kitchenid, requestquantity, approve_quantity, stock_id, required_date, etc.)
          itemid: it.id,
          kitchenid: kitchenId,
          recivedquantity: alreadyReceived ? it.recieved_quantity : "",
          price: it.price != null ? it.price : "",
        };
      });
      setinputrecievedata(initialData);
    }
  }, [itemDetails, kitchenId]);

  const submitrecievedata = async () => {
    try {
      // Send only items that are NOT locked (not yet received OR within 24h window)
      const payload = inputrecievedata.filter((row, idx) => {
        const sourceItem = itemDetails[idx];
        return !isReceiveLocked(sourceItem);
      });

      if (payload.length === 0) {
        alert("All items are locked (24-hour edit window expired).");
        return;
      }

      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/recivequantity/",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setWebcamRow(null);
      setCapturedImages([]);
      setCurrentFacingMode("user");
      fetchRequisitionList();
    } catch (err) {
      const backendMsg = err?.response?.data?.message;
      if (err?.response?.status === 403 && backendMsg) {
        alert(backendMsg);
      } else {
        alert("Something went wrong. Please try again.");
        console.log("submit error:", err);
      }
    }
  };
  const [formErrorPanding, setFormErrorPanding] = useState("");

  const [getPandingValue, setPandingValue] = useState([]);
  const [getPandingValueUpdate, setPandingValueUpdate] = useState([]);
  const [formError, setFormError] = useState("");

  const pandingValueRecevi = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/item-request-list/${pk}/`
      );
      setPandingValue(response.data.requisitiondataitem);
      setPandingValueUpdate(response.data.requisitiondataitem);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  const handleReceivedQuantityChange = (index, value) => {
    const updated = getPandingValueUpdate.map((item, i) =>
      i === index ? { ...item, pendingquantity: parseInt(value) || 0 } : item
    );
    setPandingValueUpdate(updated);
  };

  useEffect(() => {
    console.log("Original:", getPandingValue);
    console.log("Updated:", getPandingValueUpdate);
  }, [getPandingValueUpdate]);

  const [receivedQuantities, setReceivedQuantities] = useState({});

  useEffect(() => {
    [...getPandingValue, ...itemDetails].forEach((item) => {
      if (!webcamRefs.current[item.id]) {
        webcamRefs.current[item.id] = React.createRef();
      }
    });
  }, [getPandingValue, itemDetails]);

  const handleQtyChange = (index, id, value) => {
    handleReceivedQuantityChange(index, value);
    setReceivedQuantities((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const webcamRefsPanding = useRef({});
  const [capturedImagesPanding, setCapturedImagesPanding] = useState({});
  const [webcamRowPanding, setWebcamRowPanding] = useState(null);
  const [currentFacingModePanding, setCurrentFacingModePanding] =
    useState("user");

  const videoConstraints = {
    facingMode: currentFacingModePanding,
  };

  const captureImagePanding = (itemId) => {
    const webcamInstance = webcamRefsPanding.current[itemId];
    const imageSrc = webcamInstance?.getScreenshot();
    if (!imageSrc) return;
    setCapturedImagesPanding((prev) => ({ ...prev, [itemId]: imageSrc }));
  };

  const removeImagePanding = (itemId) => {
    setCapturedImagesPanding((prev) => {
      const updated = { ...prev };
      delete updated[itemId];
      return updated;
    });
  };

  const toggleFacingModePanding = () => {
    setCurrentFacingModePanding((prevMode) =>
      prevMode === "user" ? "environment" : "user"
    );
  };
  const submitPandingValue = async () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user?.kitchen) {
      setFormErrorPanding("Kitchen ID not found.");
      return;
    }

    try {
      const payload = getPandingValueUpdate.map((item) => ({
        pendingquantity: parseInt(item.pendingquantity),
        stock_id: item.stock_id,
        item_request_id: item.id,
        kitchen_id: user.kitchen,
        vendor_id: item.vendor_id,
        image: capturedImagesPanding[item.id] || null,
      }));

      const response = await axios.post(
        "https://ims-backend.indevconsultancy.in/api/pendingquantity/",
        payload
      );

      if (response.status === 200) {
        fetchRequisitionList();
        setWebcamRowPanding(null);
        setCapturedImagesPanding({});
        setCurrentFacingModePanding("user");
        setFormErrorPanding("");
      }
    } catch (error) {
      console.error("Submission failed:", error);
      setFormErrorPanding("Failed to submit. Please try again.");
    }
  };

  const [getPandingDataShow, setPandingDataShow] = useState([]);

  const getPanding = async (pk) => {
    try {
      const response = await axios.get(
        `https://ims-backend.indevconsultancy.in/api/pendingquantity/?requistion_id=${pk}`
      );
      setPandingDataShow(response.data || []);
    } catch (error) {
      console.error("Error fetching item details:", error);
    }
  };

  // helper to format date like 'DD/MM/YYYY' (or change as desired)
  const formatDateForExport = (isoDate) => {
    if (!isoDate) return "";
    try {
      const d = new Date(isoDate);
      if (isNaN(d)) return isoDate;
      return d.toLocaleDateString("en-GB");
    } catch {
      return isoDate;
    }
  };

  const escapeForCSV = (value) => {
    if (value == null) return "";
    const str = String(value).replace(/\r?\n|\r/g, " ");
    if (str.includes(",") || str.includes('"')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const PurchaseList = async () => {
    navigate("/PurchaseList");

  }
  const handleExportListPDF = async () => {
    try {
      if (!requisitionList || requisitionList.length === 0) {
        alert("No data to export.");
        return;
      }

      // Fetch item details for ALL filtered requisitions in parallel
      const fetchItems = (pk) =>
        axios
          .get(`http://127.0.0.1:8000/api/item-request-list/${pk}/`)
          .then((res) => res.data.requisitiondataitem || [])
          .catch(() => []);

      const allItemsByReqRaw = await Promise.all(
        requisitionList.map(async (req) => ({
          reqid: req.reqid,
          requestdate: req.requestdate,
          status: req.status,
          items: await fetchItems(req.reqid),
        }))
      );

      // Apply Item filter (if user selected an item, keep only matching rows)
      const allItemsByReq = selectedItem
        ? allItemsByReqRaw
          .map((req) => ({
            ...req,
            items: req.items.filter(
              (it) =>
                (it.stock || it.stock_name || "")
                  .toString()
                  .trim()
                  .toLowerCase() === selectedItem.toLowerCase()
            ),
          }))
          .filter((req) => req.items.length > 0) // drop requisitions with no matching items
        : allItemsByReqRaw;

      if (allItemsByReq.length === 0) {
        alert("No matching items found for the selected filter.");
        return;
      }

      const pdf = new jsPDF("l", "mm", "a4");
      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const marginX = 10;
      const usableWidth = pageWidth - marginX * 2;

      // Main title
      const drawMainHeader = () => {
        pdf.setFontSize(14);
        pdf.setFont(undefined, "bold");
        pdf.text("Requisition Details Report", pageWidth / 2, 10, { align: "center" });
        pdf.setFontSize(9);
        pdf.setFont(undefined, "normal");
        const filterLine = [
          selectedVendor ? `Vendor: ${selectedVendor}` : null,
          selectedItem ? `Item: ${selectedItem}` : null,
          startDateFilter ? `From: ${startDateFilter}` : null,
          endDateFilter ? `To: ${endDateFilter}` : null,
          `Requisitions: ${allItemsByReq.length}`,
        ]
          .filter(Boolean)
          .join("   |   ");
        pdf.text(filterLine, pageWidth / 2, 16, { align: "center" });
      };

      // Item columns (same as View Details modal, minus the image)
      const headers = [
        "S.No.",
        "Category",
        "Vendor",
        "Item",
        "Requested",
        "Required Date",
        "Approved",
        "Approve Date",
        "Received",
        "Price",
        "Amount",
      ];
      const colWidths = [12, 28, 32, 32, 20, 26, 20, 26, 20, 20, 24];
      const totalColW = colWidths.reduce((a, b) => a + b, 0);
      const scale = usableWidth / totalColW;
      const widths = colWidths.map((w) => w * scale);
      const rowHeight = 7;

      const drawRow = (cells, y, opts = {}) => {
        let x = marginX;
        pdf.setFontSize(8);
        if (opts.header) {
          pdf.setFillColor(25, 55, 135);
          pdf.setTextColor(255, 255, 255);
          pdf.setFont(undefined, "bold");
          pdf.rect(marginX, y, usableWidth, rowHeight, "F");
        } else if (opts.subHeader) {
          pdf.setFillColor(230, 240, 255);
          pdf.setTextColor(0, 0, 0);
          pdf.setFont(undefined, "bold");
          pdf.rect(marginX, y, usableWidth, rowHeight, "F");
          pdf.text(String(cells[0] ?? ""), marginX + 2, y + rowHeight / 2 + 1.5);
          return;
        } else if (opts.total) {
          pdf.setFillColor(200, 230, 255);
          pdf.setTextColor(0, 0, 0);
          pdf.setFont(undefined, "bold");
          pdf.rect(marginX, y, usableWidth, rowHeight, "F");
        } else {
          pdf.setTextColor(0, 0, 0);
          pdf.setFont(undefined, "normal");
        }
        cells.forEach((c, i) => {
          pdf.rect(x, y, widths[i], rowHeight);
          pdf.text(String(c ?? ""), x + 1.5, y + rowHeight / 2 + 1.5, {
            maxWidth: widths[i] - 3,
          });
          x += widths[i];
        });
      };

      const statusText = {
        0: "Pending",
        1: "Approved",
        2: "Received",
        3: "Partially Received",
      };

      const formatDate = (s) =>
        s
          ? new Date(s).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          : "-";

      drawMainHeader();
      let y = 22;

      let grandTotal = 0;
      let sNo = 1;

      allItemsByReq.forEach((req) => {
        if (!req.items || req.items.length === 0) return;

        // Sub-header for each requisition
        if (y + rowHeight * 3 > pageHeight - 10) {
          pdf.addPage();
          drawMainHeader();
          y = 22;
        }
        const reqLabel = `Requisition RE00${req.reqid}   |   Date: ${formatDate(
          req.requestdate
        )}   |   Status: ${statusText[req.status] || "Unknown"}`;
        drawRow([reqLabel], y, { subHeader: true });
        y += rowHeight;

        // Column headers
        drawRow(headers, y, { header: true });
        y += rowHeight;

        let reqTotal = 0;
        req.items.forEach((item, idx) => {
          if (y + rowHeight > pageHeight - 10) {
            pdf.addPage();
            drawMainHeader();
            y = 22;
            drawRow(headers, y, { header: true });
            y += rowHeight;
          }

          const price = parseFloat(item.price) || 0;
          const receivedQty =
            item.recieved_quantity !== 0 && item.recieved_quantity != null
              ? parseFloat(item.recieved_quantity) || 0
              : 0;
          const amount = price * receivedQty;
          reqTotal += amount;

          drawRow(
            [
              sNo++,
              item.category_name || "-",
              item.vendor_name || "-",
              item.stock || "-",
              item.requestquantity ?? "-",
              formatDate(item.required_date),
              item.approve_quantity ?? "-",
              formatDate(item.approve_date),
              receivedQty || "-",
              price.toFixed(2),
              amount.toFixed(2),
            ],
            y
          );
          y += rowHeight;
        });

        // Sub-total for this requisition
        if (y + rowHeight > pageHeight - 10) {
          pdf.addPage();
          drawMainHeader();
          y = 22;
        }
        drawRow(
          ["", "", "", "", "", "", "", "", "", "Sub Total:", reqTotal.toFixed(2)],
          y,
          { total: true }
        );
        y += rowHeight + 2;

        grandTotal += reqTotal;
      });

      // Grand total
      if (y + rowHeight > pageHeight - 10) {
        pdf.addPage();
        drawMainHeader();
        y = 22;
      }
      drawRow(
        ["", "", "", "", "", "", "", "", "", "GRAND TOTAL (INR):", grandTotal.toFixed(2)],
        y,
        { total: true }
      );

      const filename = `requisition_details_${startDateFilter || "all"}_${endDateFilter || "all"}.pdf`;
      pdf.save(filename);
    } catch (err) {
      console.error("List PDF export failed:", err);
      alert("Failed to export PDF.");
    }
  };

  const handleExportCSV = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const kitchen = user?.kitchen;
      if (!kitchen) {
        alert("Kitchen ID not found.");
        return;
      }

      const buildUrl = (paramsObj) => {
        const ps = new URLSearchParams();
        Object.entries(paramsObj).forEach(([k, v]) => {
          if (v !== undefined && v !== null && v !== "") ps.append(k, v);
        });
        return `https://api-ims.indevconsultancy.in/requisition_export_report.php?${ps.toString()}`;
      };

      const downloadFromJsonRows = (rows) => {
        if (!Array.isArray(rows) || rows.length === 0) {
          alert("No data to download.");
          return;
        }
        // Column layout matches the "Vendor Summary" export format (16 columns).
        const columns = [
          { header: "Sl. No.", get: (r, i) => i + 1 },
          { header: "reqid", get: (r) => r.reqid },
          { header: "category_name", get: (r) => r.category_name },
          { header: "stock_name", get: (r) => r.stock_name },
          { header: "requestquantity", get: (r) => r.requestquantity },
          { header: "approvequantity", get: (r) => r.approvequantity },
          { header: "vendor_name", get: (r) => r.vendor_name },
          { header: "Unit (Ex. KG, Pice, Liter etc)", get: (r) => r.units },
          { header: "recievedquantity", get: (r) => r.recievedquantity },
          { header: "Rate per Unit", get: (r) => r.price },
          {
            header: "Total (Rate X Unit)",
            get: (r) => {
              const rate = parseFloat(r.price);
              const qty = parseFloat(r.recievedquantity);
              return !isNaN(rate) && !isNaN(qty) && rate ? rate * qty : "";
            },
          },
          { header: "recieve_date", get: (r) => r.recieve_date },
          { header: "remarks", get: (r) => r.remarks },
          { header: "pendingquantity", get: (r) => r.pendingquantity },
          { header: "required_date", get: (r) => r.required_date },
          { header: "approve_date", get: (r) => r.approve_date },
        ];

        const escapeForCSV = (val) => {
          if (val == null) return "";
          const s = String(val).replace(/\r?\n|\r/g, " ");
          if (s.includes(",") || s.includes('"')) return `"${s.replace(/"/g, '""')}"`;
          return s;
        };

        // Dates come as "YYYY-MM-DD HH:MM:SS" / ISO — keep the date part only.
        const stripTime = (v) => {
          if (typeof v === "string" && /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}/.test(v)) {
            return v.split(/[ T]/)[0];
          }
          return v;
        };

        const headerRow = columns.map((c) => escapeForCSV(c.header)).join(",");
        const dataRows = rows.map((r, i) =>
          columns.map((c) => escapeForCSV(stripTime(c.get(r, i)))).join(",")
        );

        const csvContent = [headerRow, ...dataRows].join("\n");
        // Prepend UTF-8 BOM so Excel renders Devanagari/Unicode names correctly.
        const blob = new Blob(["﻿" + csvContent], { type: "text/csv;charset=utf-8;" });
        const vendorPart = selectedVendor ? `_vendor_${String(selectedVendor)}` : "";
        const filename = `vendor_summary_${kitchen}_${startDateFilter || "all"}_${endDateFilter || "all"}${vendorPart}.csv`;
        const blobUrl = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(blobUrl);
      };

      // base params
      const baseParams = {
        kitchen_id: kitchen,
        start_date: startDateFilter || undefined,
        end_date: endDateFilter || undefined,
      };

      // function producing date-variant attempts
      const makeAttemptsFromParams = (p) => {
        const list = [];
        list.push({ ...p }); // original
        if (endDateFilter) {
          const e = new Date(endDateFilter);
          e.setDate(e.getDate() + 1);
          list.push({ ...p, end_date: e.toISOString().slice(0, 10) }); // try inclusive end+1
        }
        if (startDateFilter && endDateFilter) {
          const startDT = `${startDateFilter} 00:00:00`;
          const endDT = `${endDateFilter} 23:59:59`;
          list.push({ ...p, start_date: startDT, end_date: endDT });
          const e2 = new Date(endDateFilter);
          e2.setDate(e2.getDate() + 1);
          list.push({ ...p, start_date: startDT, end_date: `${e2.toISOString().slice(0, 10)} 23:59:59` });
        }
        return list;
      };

      // prepare attempts (prefer vendor_id if selected)
      let attempts = [];
      if (selectedVendor) {
        attempts.push(...makeAttemptsFromParams({ ...baseParams, vendor_id: selectedVendor }));
      }
      // also try without vendor (in case combined filter server-side bug)
      attempts.push(...makeAttemptsFromParams({ ...baseParams }));
      // final fallback: all kitchen data
      attempts.push({ kitchen_id: kitchen });

      // dedupe attempt urls
      const seen = new Set();
      const uniqueAttempts = attempts
        .map((p) => ({ p, url: buildUrl(p) }))
        .filter(({ url }) => {
          if (seen.has(url)) return false;
          seen.add(url);
          return true;
        });
      // Local date filter (always applied to whatever server returns, so that
      // even if the server ignores the date params the CSV still respects them).
      const parseDateOnly = (s) => {
        if (!s) return null;
        const m = s.toString().trim().split(" ")[0];
        const d = new Date(m + "T00:00:00");
        return isNaN(d) ? null : d;
      };
      const startD = startDateFilter ? new Date(startDateFilter + "T00:00:00") : null;
      const endD = endDateFilter ? new Date(endDateFilter + "T23:59:59") : null;

      // Normalize reqid (string, no leading zeros, no "RE" prefix)
      const normalizeReqId = (v) => {
        if (v == null) return "";
        return String(v).trim().replace(/^RE0*/i, "").replace(/^0+/, "");
      };

      // Build the set of requisition IDs currently visible in the table
      const visibleReqIds = new Set(
        (requisitionList || [])
          .map((r) => normalizeReqId(r.reqid ?? r.req_id ?? r.requisition_id ?? r.pk))
          .filter(Boolean)
      );
      console.log("Visible reqids in table:", Array.from(visibleReqIds));

      const getRowReqId = (row) =>
        normalizeReqId(
          row.reqid ??
          row.req_id ??
          row.requisition_id ??
          row.requisitionid ??
          row.requisition_no ??
          row.reqId
        );

      const applyClientFilters = (rows) => {
        let out = rows;
        console.log("Raw row count from server:", out.length);
        if (out.length > 0) {
          console.log("Sample row keys:", Object.keys(out[0]));
          console.log("Sample row:", out[0]);
        }
        // 1. Restrict to requisitions that are visible in the current filtered table
        if (visibleReqIds.size > 0) {
          out = out.filter((r) => {
            const id = getRowReqId(r);
            return id && visibleReqIds.has(id);
          });
          console.log("After reqid filter:", out.length);
        }
        // 2. Vendor filter (extra safety in case server ignored it)
        if (selectedVendor) {
          out = out.filter(
            (r) =>
              String(r.vendor_id) === String(selectedVendor) ||
              String(r.vendor_name || "").toLowerCase() ===
              String(selectedVendor).toLowerCase()
          );
        }


        // 3. Date range filter (extra safety)
        if (startD || endD) {
          out = out.filter((r) => {
            const dateStr =
              r.required_date || r.recieve_date || r.approve_date || r.requestdate || "";
            const d = parseDateOnly(dateStr);
            if (!d) return false;
            if (startD && d < startD) return false;
            if (endD && d > endD) return false;
            return true;
          });
          console.log("After date filter:", out.length);
        }
        return out;
      };

      // try server-side attempts first
      for (const { p, url } of uniqueAttempts) {
        console.log("Trying export URL:", url);
        try {
          const resp = await axios.get(url, { responseType: "json" });
          const data = resp.data;
          const rows = Array.isArray(data) ? data : data?.data;
          if (Array.isArray(rows) && rows.length > 0) {
            // ALWAYS apply client-side filter before download
            const filtered = applyClientFilters(rows);
            if (filtered.length === 0) {
              alert(
                "No data for the selected date range / vendor. Try widening the filters."
              );
              return;
            }
            downloadFromJsonRows(filtered);
            return;
          }
          console.log("No data for this attempt:", url);
        } catch (err) {
          console.warn("Attempt failed:", url, err);
        }
      }

      // --- SERVER returned no rows for any attempt: CLIENT-SIDE fallback ---
      // Fetch broader dataset (vendor-only if vendor selected, else kitchen-only),
      // then filter locally by start/end dates and export.
      try {
        const fallbackParams = { kitchen_id: kitchen };
        // if vendor selected, fetch vendor-only dataset (without dates)
        if (selectedVendor) fallbackParams.vendor_id = selectedVendor;

        const fallbackUrl = buildUrl(fallbackParams);
        console.log("Fallback fetch (broad dataset) URL:", fallbackUrl);
        const fallbackResp = await axios.get(fallbackUrl, { responseType: "json" });
        const fallbackData = fallbackResp.data;
        const allRows = Array.isArray(fallbackData) ? fallbackData : fallbackData?.data || [];

        if (!allRows.length) {
          alert("No data available for the selected filters. (Tried server and client-side fallback.)");
          return;
        }

        // local date filter function (inclusive)
        const parseDateOnly = (s) => {
          if (!s) return null;
          // try ISO-like 'YYYY-MM-DD' or 'YYYY-MM-DD HH:MM:SS'
          const m = s.toString().trim().split(" ")[0];
          const d = new Date(m + "T00:00:00");
          return isNaN(d) ? null : d;
        };

        const startD = startDateFilter ? new Date(startDateFilter + "T00:00:00") : null;
        const endD = endDateFilter ? new Date(endDateFilter + "T23:59:59") : null;

        const filtered = allRows.filter((r) => {
          // prefer required_date but fall back to recieve_date or approve_date if needed
          const dateStr = r.required_date || r.recieve_date || r.approve_date || "";
          const d = parseDateOnly(dateStr);
          if (!d) {
            // if row has no date, drop it when date filter present
            return !startD && !endD;
          }
          if (startD && d < startD) return false;
          if (endD && d > endD) return false;
          return true;
        });

        if (!filtered.length) {
          alert("No data available for the selected filters after client-side filtering. Try widening the date range or removing the vendor filter.");
          return;
        }

        // export the filtered set
        downloadFromJsonRows(filtered);
        return;
      } catch (err) {
        console.error("Client-side fallback failed:", err);
        alert("Export failed (and client-side fallback also failed). See console for details.");
      }
    } catch (err) {
      console.error("Export error:", err);
      alert("Export failed. See console for details.");
    }
  };


  // Calculate totals for the view modal
  const calculateTotals = () => {
    let totalRequested = 0;
    let totalApproved = 0;
    let totalReceived = 0;
    let totalAmount = 0;

    itemDetails.forEach((item) => {
      const requested = parseFloat(item.requestquantity) || 0;
      const approved = parseFloat(item.approve_quantity) || 0;
      const received = item.recieved_quantity !== 0
        ? parseFloat(item.recieved_quantity) || 0
        : parseFloat(inputrecievedata.find(d => d.id === item.id)?.recivedquantity) || 0;
      const price = parseFloat(item.price) || 0;

      totalRequested += requested;
      totalApproved += approved;
      totalReceived += received;
      totalAmount += (price * received);
    });

    return {
      totalRequested: totalRequested.toFixed(2),
      totalApproved: totalApproved.toFixed(2),
      totalReceived: totalReceived.toFixed(2),
      totalAmount: totalAmount.toFixed(2)
    };
  };

  return (
    <div className="container-fluid px-2">
      <div className="content">
        <div className="container-fluid">
          <div className="row align-items-center justify-content-between py-2">
            <div className="col-md-6 col-6">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb justify-content-start mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/mobilehome">Home</Link>
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-6 text-end">
              <span className="fs-1">Requisition List</span>
            </div>
          </div>

          <div className="row g-3">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header border-info">
                  <form onSubmit={handleSearch}>
                    <div className="row g-3">
                      <div className="col-lg">
                        <label className="form-label">Vendor Name</label>
                        <select
                          className="form-control"
                          value={selectedVendor}
                          onChange={(e) => setSelectedVendor(e.target.value)}
                        >
                          <option value="">Select Vendor</option>
                          {vendors.map((vendor) => {
                            const id = vendor.vendor_id ?? vendor.id ?? "";
                            const name = (
                              vendor.vendor_name ??
                              vendor.name ??
                              ""
                            )
                              .toString()
                              .trim();
                            return (
                              <option key={id || name} value={String(id)}>
                                {name || "Unnamed vendor"}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                      <div className="col-lg">
                        <label className="form-label">Item Name</label>
                        <select
                          className="form-control"
                          value={selectedItem}
                          onChange={(e) => setSelectedItem(e.target.value)}
                        >
                          <option value="">All Items</option>
                          {itemOptions.map((name) => (
                            <option key={name} value={name}>
                              {name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-lg">
                        <label className="form-label">Start Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDateFilter}
                          onChange={(e) => setStartDateFilter(e.target.value)}
                          placeholder="Start date"
                        />
                      </div>

                      <div className="col-lg">
                        <label className="form-label">End Date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDateFilter}
                          onChange={(e) => setEndDateFilter(e.target.value)}
                          placeholder="End date"
                        />
                      </div>

                      <div className="col-lg-2">
                        <label className="form-label d-block">&nbsp;</label>
                        <button type="submit" className="btn btn-primary w-100">
                          Search
                        </button>
                      </div>

                      <div className="col-lg-1">
                        <label className="form-label d-block">&nbsp;</label>
                        <button
                          type="button"
                          className="btn btn-outline-dark w-100"
                          onClick={() => {
                            setFilterDate("");
                            setStartDateFilter("");
                            setEndDateFilter("");
                            setSelectedVendor("");
                            setSelectedItem("");
                            fetchRequisitionList();
                          }}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                  </form>
                </div>

                <div className="card-body">
                  <div className="row align-items-center g-0 mb-3">
                    <div className="col-sm-7">
                      <h6 className="fw-bold mb-0">
                        Total Requisition(s):{" "}
                        <span className="text-primary">{requisitionList.length}</span>
                      </h6>
                    </div>

                    <div className="col-sm-5 text-end">
                      <button
                        className="btn btn-outline-primary btn-sm me-2"
                        type="button"
                        onClick={PurchaseList}
                      >
                        <i className="fas fa-shopping-cart me-1"></i> Purchase List
                      </button>

                      <button
                        className="btn btn-primary btn-sm me-2"
                        type="button"
                        onClick={handleExportCSV}
                      >
                        <i className="fas fa-file-export me-1"></i> Export CSV
                      </button>
                      <button
                        className="btn btn-danger btn-sm"
                        type="button"
                        onClick={async (e) => {
                          const btn = e.currentTarget;
                          const original = btn.innerHTML;
                          btn.disabled = true;
                          btn.innerHTML =
                            '<span class="spinner-border spinner-border-sm me-1"></span> Preparing...';
                          try {
                            await handleExportListPDF();
                          } finally {
                            btn.disabled = false;
                            btn.innerHTML = original;
                          }
                        }}
                      >
                        <i className="fas fa-file-pdf me-1"></i> Export PDF
                      </button>
                    </div>
                  </div>

                  <div className="table-responsive scrollbar">
                    <table className="table text-center table-bordered table-striped fs--1 mb-0">
                      <thead className="bg-primary text-white">
                        <tr>
                          <th style={{ width: '5%' }}>S.No.</th>
                          <th style={{ width: '15%' }}>Requisition ID</th>
                          <th style={{ width: '15%' }}>Date</th>
                          <th style={{ width: '15%' }}>Status</th>
                          <th style={{ width: '20%' }}>Total Amount (₹)</th>
                          <th style={{ width: '30%' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedList.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center py-5">
                              <div className="text-muted">
                                <i className="fas fa-clipboard-list fa-3x mb-3 opacity-50"></i>
                                <h5>No Requisitions Found</h5>
                                <p className="mb-0">There are no requisitions matching your criteria.</p>
                              </div>
                            </td>
                          </tr>
                        ) : (
                          paginatedList.map((item, index) => {
                            // Safely parse total amount
                            const totalAmount = parseFloat(item.total_amount) || 0;
                            const formattedAmount = totalAmount.toLocaleString('en-IN', {
                              minimumFractionDigits: 2,
                              maximumFractionDigits: 2
                            });

                            return (
                              <tr key={item.pk || item.reqid || index} className="align-middle">
                                <td className="fw-bold">
                                  {(currentPage - 1) * itemsPerPage + index + 1}
                                </td>
                                <td>
                                  <span className="fw-bold text-primary">RE00{item.reqid || item.reqid}</span>
                                </td>
                                <td>
                                  {item.requestdate ?
                                    new Date(item.requestdate).toLocaleDateString('en-GB', {
                                      day: '2-digit',
                                      month: 'short',
                                      year: 'numeric'
                                    }) : '-'
                                  }
                                </td>
                                <td>
                                  <span
                                    className={`badge bg-${statusColorMap[item.status] || "secondary"} px-3 py-2`}
                                    style={{ fontSize: '0.85rem' }}
                                  >
                                    <i className={`fas fa-${item.status === 0 ? 'clock' :
                                      item.status === 1 ? 'check-circle' :
                                        item.status === 2 ? 'check-double' :
                                          item.status === 3 ? 'hourglass-half' : 'times-circle'
                                      } me-1`}></i>
                                    {statusMap[item.status] || "Unknown"}
                                  </span>
                                </td>
                                <td className="fw-bold text-success" style={{ fontSize: '1.1rem' }}>
                                  {item.amount > 0 ? `₹${item.amount}` : '-'}
                                </td>
                                <td>
                                  <div className="d-flex gap-2 justify-content-center">
                                    <button
                                      className="btn btn-sm btn-outline-primary"
                                      type="button"
                                      data-bs-toggle="modal"
                                      data-bs-target="#viweModal"
                                      onClick={() => {
                                        setSelectedItemId(item.reqid);
                                        fetchRequisitionItemDetails(item.reqid);
                                        removeImage();
                                      }}
                                      title="View Details"
                                    >
                                      <i className="fas fa-eye me-1"></i> View Details
                                    </button>
                                    {item.status === 3 && (
                                      <button
                                        className="btn btn-sm btn-outline-warning"
                                        type="button"
                                        data-bs-toggle="modal"
                                        data-bs-target="#editModal"
                                        onClick={() => pandingValueRecevi(item.reqid)}
                                        title="Receive Pending"
                                      >
                                        <i className="fas fa-truck me-1"></i> Receive
                                      </button>
                                    )}
                                  </div>
                                </td>
                              </tr>
                            );
                          })
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination with improved styling */}
                  {requisitionList.length > 0 && (
                    <div className="d-flex justify-content-between align-items-center mt-4">
                      <div className="text-muted">
                        Showing {(currentPage - 1) * itemsPerPage + 1} to {Math.min(currentPage * itemsPerPage, requisitionList.length)} of {requisitionList.length} entries
                      </div>
                      <div className="d-flex gap-2">
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                          disabled={currentPage === 1}
                        >
                          <i className="fas fa-chevron-left me-1"></i> Previous
                        </button>
                        <span className="px-3 py-1 bg-light rounded">
                          Page {currentPage} of {totalPages}
                        </span>
                        <button
                          className="btn btn-outline-primary btn-sm"
                          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                          disabled={currentPage === totalPages}
                        >
                          Next <i className="fas fa-chevron-right ms-1"></i>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ========== EDIT MODAL ========== */}
      <div
        className="modal fade"
        id="editModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            {/* Modal Header */}
            <div className="modal-header">
              <h5 className="modal-title">Pending Quantity Received</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>

            {/* Modal Body */}
            <div className="modal-body px-2 px-md-4">
              {formErrorPanding && (
                <div className="alert alert-danger">{formErrorPanding}</div>
              )}

              {getPandingValue.length === 0 ? (
                <p>No items available</p>
              ) : (
                <div className="table-responsive">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>Category Name</th>
                        <th>Vendor Name</th>
                        <th>Item</th>
                        <th>Pending Quantity</th>
                        <th>Pending Received Quantity</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getPandingValue.map((item, index) =>
                        item.pendingquantity > 0 ? (
                          <tr key={item.id}>
                            <td>{item.category_name}</td>
                            <td>{item.vendor_name}</td>
                            <td>{item.stock}</td>
                            <td>{item.pendingquantity}</td>
                            <td>
                              <div style={{ display: "inline-block" }}>
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    minWidth:
                                      window.innerWidth <= 576
                                        ? "120px"
                                        : "auto",
                                  }}
                                  onChange={(e) =>
                                    handleQtyChange(
                                      index,
                                      item.id,
                                      e.target.value
                                    )
                                  }
                                />
                              </div>
                            </td>
                            <td>
                              {capturedImagesPanding[item.id] ? (
                                <div>
                                  <img
                                    src={capturedImagesPanding[item.id]}
                                    alt="Captured"
                                    width={150}
                                    className="border rounded"
                                  />
                                  <button
                                    onClick={() => removeImagePanding(item.id)}
                                    className="btn btn-danger btn-sm ms-2"
                                  >
                                    Remove Image
                                  </button>
                                </div>
                              ) : (
                                <>
                                  {webcamRowPanding === item.id ? (
                                    <div>
                                      <Webcam
                                        audio={false}
                                        ref={(el) =>
                                        (webcamRefsPanding.current[item.id] =
                                          el)
                                        }
                                        screenshotFormat="image/jpeg"
                                        videoConstraints={{
                                          facingMode: currentFacingModePanding,
                                        }}
                                        className="border rounded"
                                        width={150}
                                      />
                                      <div className="d-flex gap-2 mt-2">
                                        <button
                                          onClick={() =>
                                            captureImagePanding(item.id)
                                          }
                                          className="btn btn-success btn-sm"
                                        >
                                          Capture
                                        </button>
                                        <button
                                          onClick={toggleFacingModePanding}
                                          className="btn btn-primary btn-sm"
                                        >
                                          Switch Camera
                                        </button>
                                        <button
                                          onClick={() =>
                                            setWebcamRowPanding(null)
                                          }
                                          className="btn btn-secondary btn-sm"
                                        >
                                          Close
                                        </button>
                                      </div>
                                    </div>
                                  ) : (
                                    <button
                                      onClick={() =>
                                        setWebcamRowPanding(item.id)
                                      }
                                      className="btn btn-warning btn-sm"
                                    >
                                      Open Camera
                                    </button>
                                  )}
                                </>
                              )}
                            </td>
                          </tr>
                        ) : null
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-primary"
                data-bs-dismiss="modal"
                onClick={submitPandingValue}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* ========== VIEW MODAL ========== */}
      <div
        className="modal fade"
        id="viweModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">View Requisition Details</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              />
            </div>
            <div
              className="modal-body py-2"
              style={{ overflowY: "scroll", height: "550px" }}
              ref={viewModalRef}
            >
              {/* Total Summary Cards */}
              {itemDetails.length > 0 && (
                <div className="row mb-3">
                  <div className="col-md-3">
                    <div className="card bg-light">
                      <div className="card-body py-2">
                        <small className="text-muted">Total Requested</small>
                        <h6 className="mb-0 fw-bold">
                          {calculateTotals().totalRequested}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-light">
                      <div className="card-body py-2">
                        <small className="text-muted">Total Approved</small>
                        <h6 className="mb-0 fw-bold">
                          {calculateTotals().totalApproved}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-light">
                      <div className="card-body py-2">
                        <small className="text-muted">Total Received</small>
                        <h6 className="mb-0 fw-bold">
                          {calculateTotals().totalReceived}
                        </h6>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <div className="card bg-success text-white">
                      <div className="card-body py-2">
                        <small>Total Amount</small>
                        <h5 className="mb-0 fw-bold">
                          ₹{calculateTotals().totalAmount}
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {itemDetails.length === 0 ? (
                <p className="text-center text-danger">No data found</p>
              ) : (
                <div className="table-responsive">
                  <table className="table text-center table-bordered table-striped fs--1 mb-0">
                    <thead className="bg-primary text-white">
                      <tr>
                        <th>S.No.</th>
                        <th>Category Name</th>
                        <th>Vendor Name</th>
                        <th>Item</th>
                        <th>Requested</th>
                        <th>Required Date</th>
                        <th>Approved</th>
                        <th>Approve Date</th>
                        <th>Received</th>
                        <th>Price (₹)</th>
                        <th>Amount (₹)</th>
                        <th>Image</th>
                      </tr>
                    </thead>
                    <tbody>
                      {itemDetails.map((item, index) => {
                        const locked = isReceiveLocked(item);
                        const alreadyReceived = parseFloat(item.recieved_quantity || 0) > 0;

                        // Effective received quantity (for amount calculation)
                        const effectiveQty = alreadyReceived
                          ? (inputrecievedata[index]?.recivedquantity ?? item.recieved_quantity)
                          : (inputrecievedata[index]?.recivedquantity || 0);

                        // Effective price (use edited price if user changed it, else original)
                        const effectivePrice =
                          inputrecievedata[index]?.price != null && inputrecievedata[index]?.price !== ""
                            ? parseFloat(inputrecievedata[index]?.price)
                            : parseFloat(item.price) || 0;

                        const amount = effectivePrice * (parseFloat(effectiveQty) || 0);

                        return (
                          <tr key={item.id}>
                            <td className="align-middle">{index + 1}</td>
                            <td className="align-middle">{item.category_name}</td>
                            <td className="align-middle">{item.vendor_name}</td>
                            <td className="align-middle">{item.stock}</td>
                            <td className="align-middle">{item.requestquantity}</td>
                            <td className="align-middle">
                              {item.required_date ?
                                new Date(item.required_date).toLocaleDateString('en-GB') : '-'
                              }
                            </td>
                            <td className="align-middle">{item.approve_quantity}</td>
                            <td className="align-middle">
                              {item.approve_date ?
                                new Date(item.approve_date).toLocaleDateString('en-GB') : '-'
                              }
                            </td>
                            <td className="align-middle">
                              {locked ? (
                                <span
                                  className="fw-bold text-muted"
                                  title="Edit window expired (24 hrs)"
                                >
                                  {item.recieved_quantity}
                                  <i className="fas fa-lock ms-1 text-secondary" />
                                </span>
                              ) : (
                                <input
                                  type="number"
                                  className="form-control"
                                  style={{
                                    minWidth: window.innerWidth <= 576 ? "120px" : "80px",
                                    width: "80px",
                                    margin: "0 auto"
                                  }}
                                  value={
                                    inputrecievedata[index]?.recivedquantity ??
                                    (alreadyReceived ? item.recieved_quantity : "")
                                  }
                                  onChange={(e) =>
                                    handlereceivedvalue(
                                      index,
                                      "recivedquantity",
                                      e.target.value
                                    )
                                  }
                                />
                              )}
                            </td>
                            <td className="align-middle">
                              {locked ? (
                                <span className="fw-bold text-muted">
                                  ₹{(parseFloat(item.price) || 0).toFixed(2)}
                                </span>
                              ) : (
                                <input
                                  type="number"
                                  step="0.01"
                                  className="form-control"
                                  style={{ width: "90px", margin: "0 auto" }}
                                  value={
                                    inputrecievedata[index]?.price ??
                                    (item.price != null ? item.price : "")
                                  }
                                  onChange={(e) =>
                                    handlereceivedvalue(index, "price", e.target.value)
                                  }
                                />
                              )}
                            </td>
                            <td className="align-middle fw-bold text-primary">
                              ₹{amount.toFixed(2)}
                            </td>
                            <td className="align-middle">
                              {item.recieved_quantity !== 0 ? (
                                <img
                                  src={item.imageurl}
                                  alt="Captured"
                                  className="img-thumbnail"
                                  style={{
                                    width: "80px",
                                    height: "60px",
                                    objectFit: "cover",
                                  }}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.src =
                                      "https://www.shutterstock.com/shutterstock/photos/161251868/display_1500/stock-vector-photo-coming-soon-symbol-161251868.jpg";
                                  }}
                                />
                              ) : webcamRow === item.id ? (
                                <div className="d-flex flex-column align-items-center gap-2">
                                  <Webcam
                                    audio={false}
                                    ref={webcamRefs.current[item.id]}
                                    screenshotFormat="image/jpeg"
                                    className="rounded border"
                                    videoConstraints={{
                                      facingMode: currentFacingMode,
                                    }}
                                    style={{
                                      width: "150px",
                                      height: "100px",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <div className="d-flex gap-2">
                                    <button
                                      className="btn btn-success btn-sm"
                                      onClick={() => captureImage(item.id)}
                                    >
                                      Capture
                                    </button>
                                    <button
                                      className="btn btn-info btn-sm"
                                      onClick={() =>
                                        setCurrentFacingMode((prev) =>
                                          prev === "user" ? "environment" : "user"
                                        )
                                      }
                                    >
                                      Switch
                                    </button>
                                    <button
                                      className="btn btn-secondary btn-sm"
                                      onClick={() => {
                                        setWebcamRow(null);
                                        setCurrentFacingMode("user");
                                      }}
                                    >
                                      Cancel
                                    </button>
                                  </div>
                                </div>
                              ) : capturedImages[item.id] ? (
                                <img
                                  src={capturedImages[item.id]}
                                  alt="Captured"
                                  className="img-thumbnail"
                                  style={{
                                    width: "80px",
                                    height: "60px",
                                    objectFit: "cover",
                                  }}
                                />
                              ) : (
                                <button
                                  className="btn btn-outline-primary btn-sm"
                                  onClick={() => {
                                    setWebcamRow(item.id);
                                    setCurrentFacingMode("user");
                                  }}
                                >
                                  <i className="bi bi-camera me-1"></i> Camera
                                </button>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>

                    {/* Table Footer with Totals */}
                    {itemDetails.length > 0 && (
                      <tfoot className="table-info fw-bold">
                        <tr>
                          <td colSpan="8" className="text-end">GRAND TOTAL:</td>
                          <td>{calculateTotals().totalReceived}</td>
                          <td></td>
                          <td className="text-primary">₹{calculateTotals().totalAmount}</td>
                          <td></td>
                        </tr>
                      </tfoot>
                    )}
                  </table>
                </div>
              )}
            </div>

            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={exportModalToCSV}
                disabled={itemDetails.length === 0}
              >
                <i className="fas fa-file-export me-1"></i> Export CSV
              </button>
              <button
                type="button"
                className="btn btn-danger"
                onClick={exportModalToPDF}
                disabled={itemDetails.length === 0}
              >
                <i className="bi bi-file-earmark-pdf me-1"></i> Export PDF
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              {itemDetails.some((item) => !isReceiveLocked(item)) && (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={submitrecievedata}
                >
                  Submit Received
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RequisitionPO;